import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { UserByIdQuery } from '../gql/graphql';

const getUserQuery = graphql(/* GraphQL */ `
  query userById($userId: String!) {
    userById(userid: $userId) {
      userId
      auth0Id
      email
      fullName
      gender
      phone
      dateOfBirth
      specialRequest
    }
  }
`);

const useGetUser = (userId: string, enabled: boolean = false) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, error, isLoading, refetch, isFetching } =
    useQuery<UserByIdQuery>({
      queryKey: ['user', userId],
      queryFn: async () =>
        graphqlRequest<UserByIdQuery>(
          getUserQuery,
          { userId },
          enabled && isAuthenticated ? getAccessTokenSilently : undefined,
        ),
      enabled: enabled && isAuthenticated,
      retry: shouldRetryQuery,
    });

  const user = data?.userById;

  return {
    user,
    isLoading,
    isError: !!error,
    error,
    refetch,
    isFetching,
  };
};

export default useGetUser;
